import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { AdminThemeProvider } from '@/contexts/AdminThemeContext';
import { AuthProvider } from '@/contexts/AuthContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import { Toaster } from '@/components/ui/sonner';
import HomePage from '@/pages/HomePage';
import DynamicPage from '@/pages/DynamicPage';
import BlogListPage from '@/pages/BlogListPage';
import BlogPostPage from '@/pages/BlogPostPage';
import AdminLogin from '@/admin/AdminLogin';
import AdminDashboard from '@/admin/AdminDashboard';
import AdminPages from '@/admin/AdminPages';
import PageEditor from '@/admin/PageEditor';
import AdminContacts from '@/admin/AdminContacts';
import AdminSettings from '@/admin/AdminSettings';
import AdminBlog from '@/admin/AdminBlog';
import BlogEditor from '@/admin/BlogEditor';
import AdminHomePage from '@/admin/AdminHomePage';
import AdminServices from '@/admin/AdminServices';
import AdminCalendar from '@/admin/AdminCalendar';
import '@/App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <AdminThemeProvider>
            <Toaster position="top-right" />
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/blog" element={<BlogListPage />} />
              <Route path="/blog/:postId" element={<BlogPostPage />} />
              <Route path="/page/:slug" element={<DynamicPage />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/pages" element={<ProtectedRoute><AdminPages /></ProtectedRoute>} />
              <Route path="/admin/pages/new" element={<ProtectedRoute><PageEditor /></ProtectedRoute>} />
              <Route path="/admin/pages/edit/:pageId" element={<ProtectedRoute><PageEditor /></ProtectedRoute>} />
              <Route path="/admin/blog" element={<ProtectedRoute><AdminBlog /></ProtectedRoute>} />
              <Route path="/admin/blog/new" element={<ProtectedRoute><BlogEditor /></ProtectedRoute>} />
              <Route path="/admin/blog/edit/:postId" element={<ProtectedRoute><BlogEditor /></ProtectedRoute>} />
              <Route path="/admin/home" element={<ProtectedRoute><AdminHomePage /></ProtectedRoute>} />
              <Route path="/admin/services" element={<ProtectedRoute><AdminServices /></ProtectedRoute>} />
              <Route path="/admin/calendar" element={<ProtectedRoute><AdminCalendar /></ProtectedRoute>} />
              <Route path="/admin/contacts" element={<ProtectedRoute><AdminContacts /></ProtectedRoute>} />
              <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
            </Routes>
          </AdminThemeProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;